import React, { useEffect, useState } from "react";
import classes from "./Drawer.module.css";
import { useNavigate } from "react-router-dom";
import { FaXmark } from "react-icons/fa6";
import Cookies from "js-cookie";

const Drawer = ({ drawer, setDrawer, setShowModal }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (drawer) {
      // Disable scrolling
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable scrolling
      document.body.style.overflow = "";
    }

    // Optional cleanup just in case the component unmounts while drawer is open
    return () => {
      document.body.style.overflow = "";
    };
  }, [drawer]);

  return (
    <div
      className={`${classes.drawer} ${drawer && classes.show}`}
      onClick={() => setDrawer(false)}
    >
      <div
        className={classes.drawer_container}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={classes.menu_items}>
          <button className={classes.menu_item}
            onClick={() => setDrawer(false)}
            style={{ justifyContent: "flex-end" }}
          >
            <div className={classes.close_button}>
              <FaXmark className={classes.close_icon} />
            </div>
          </button>
          <div className={classes.divider}></div>


          <button className={classes.menu_item}
            onClick={() => {
              setDrawer(false);
              Cookies.remove("msisdn");
              navigate("/")
            }}
          >
            Logout
          </button>
          <div className={classes.divider}></div>

          <button className={classes.menu_item}
            onClick={() => {
              setDrawer(false);
              setShowModal(true);
            }}
          >
            Unsubscribe
          </button>

        </div>
      </div>

    </div>
  );
};

export default Drawer;